export function generatePassword(len: number) {
  const buf = new Uint8Array(len);
  // globalThis.crypto works in browsers, web workers, and Node 16+, so the
  // helper is portable to non-DOM contexts (vitest in node env, SSR, etc.).
  globalThis.crypto.getRandomValues(buf);
  const numArray = Array.from(buf);
  return btoa(String.fromCharCode.apply(null, numArray));
}
